// ============================================================
// MaintenancePage — ecran bloquant affiche quand l'admin a
// active le maintenance mode. Admin bypass automatiquement via
// email JWT (check dans App.jsx avant d'afficher cette page).
// ============================================================

import { useMemo } from 'react'
import merlinImg from '../assets/merlin.png'
import { Sparkles } from '../components/ui'
import { useAuth } from '../context/AuthContext'

export default function MaintenancePage({ message }) {
  const { signOut } = useAuth()
  const sparkleSeed = useMemo(() => Math.random(), [])

  const defaultMsg = 'Merlin est en maintenance — on repare un bug critique et on revient tres vite.'
  const displayMsg = (message && message.trim()) ? message : defaultMsg

  return (
    <div className="min-h-screen onboarding-bg flex items-center justify-center p-4 overflow-hidden relative">
      <Sparkles count={14} color="#fe8204" />
      <div className="welcome-orb welcome-orb-1" />
      <div className="welcome-orb welcome-orb-2" />

      <div className="w-full max-w-md relative z-10 welcome-fade-in text-center" key={sparkleSeed}>
        <div className="merlin-aura merlin-float inline-block mb-5">
          <img src={merlinImg} alt="Merlin" className="w-28 h-28 object-contain relative z-10"
            style={{ filter: 'drop-shadow(0 0 30px rgba(254,130,4,0.35)) brightness(1.1)' }} />
        </div>

        <h1 className="merlin-title text-4xl font-extrabold tracking-tight mb-1">Merlin</h1>
        <p className="text-xs uppercase tracking-[0.25em] mb-6" style={{ color: 'rgba(255,255,255,0.35)' }}>
          Maintenance en cours
        </p>

        <div className="merlin-welcome-bubble p-7 welcome-bubble-enter">
          <div className="w-14 h-14 rounded-full mx-auto mb-4 flex items-center justify-center"
            style={{ background: 'rgba(254,130,4,0.15)', border: '1px solid rgba(254,130,4,0.3)' }}>
            <span className="text-2xl" aria-hidden>🛠️</span>
          </div>

          <h2 className="text-xl font-bold mb-3" style={{ color: 'rgba(255,255,255,0.95)' }}>
            Maintenance en cours
          </h2>

          <p className="text-sm leading-relaxed mb-5" style={{ color: 'rgba(255,255,255,0.75)' }}>
            {displayMsg}
          </p>

          <p className="text-xs mb-5" style={{ color: 'rgba(255,255,255,0.45)' }}>
            Tes données et tes scripts sont en sécurité. On te remet en ligne des que possible.
          </p>

          <div className="flex flex-col gap-2 items-center">
            <button
              onClick={() => window.location.reload()}
              className="text-xs px-4 py-2 rounded-full font-semibold transition-all hover:scale-105"
              style={{ background: 'linear-gradient(135deg, #f59e0b, #fe8204)', color: 'white', boxShadow: '0 4px 20px rgba(245,158,11,0.3)' }}
            >
              Reessayer
            </button>
            {signOut && (
              <button
                onClick={signOut}
                className="text-xs mt-1 underline"
                style={{ color: 'rgba(255,255,255,0.4)' }}
              >
                Se deconnecter
              </button>
            )}
          </div>
        </div>

        <p className="text-xs mt-6" style={{ color: 'rgba(255,255,255,0.3)' }}>
          Question urgente ? <a href="mailto:antonin.girardeau.pro@gmail.com" className="underline hover:text-orange">antonin.girardeau.pro@gmail.com</a>
        </p>

        {/* Escape hatch admin — caché en bas, invisible aux users normaux.
            Si un jour le check isAdmin rate (race condition Supabase),
            l'admin peut bypass en cliquant ici. Le backend vérifiera
            quand meme le JWT admin pour toute action sensible. */}
        <p className="text-xs mt-2" style={{ color: 'rgba(255,255,255,0.15)' }}>
          <button
            onClick={() => {
              const url = new URL(window.location.href)
              url.searchParams.set('admin-force', '1')
              window.location.href = url.toString()
            }}
            className="hover:text-orange underline"
            style={{ color: 'rgba(255,255,255,0.25)' }}
          >
            Admin bypass
          </button>
        </p>
      </div>
    </div>
  )
}
